import { NavLink } from "react-router-dom";
import { paths } from "../../constants/paths";
import type { BlogPost } from "../../types/blog";
import styles from "../styles/blogpost/BlogPostHeader.module.css";

const BlogPostHeader = ({ post }: { post: BlogPost }) => {
  return (
    <div className={styles.blogPostHeader}>
      <div className="max-w-440 mx-auto px-4 lg:px-10 2xl:px-20">
        <div className="flex justify-center">
          <div className="w-full">
            {/* Breadcrumb */}
            <div className={styles.breadcrumb}>
              <NavLink to={paths?.home} className={styles.breadcrumbLink}>
                Home
              </NavLink>

              <span className={styles.breadcrumbSeparator}>/</span>

              <NavLink to={paths?.blog} className={styles.breadcrumbLink}>
                Blog
              </NavLink>

              <span className={styles.breadcrumbSeparator}>/</span>

              <span className={styles.breadcrumbCurrent}>{post.title}</span>
            </div>

            {/* Title */}
            <h1 className={styles.postTitle}>{post.title}</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPostHeader;
